import React from 'react';
import { searchAgentic } from './services/apiService';
import { getAgenticInfo } from './AgenticSearch';
import AgenticLoadingScreen from './AgenticLoadingScreen';

export function createAiAgentSearchContext(value) {
  return {
    query: value.trim(),
  };
}

export async function performAiAgentSearch(config, requestConfig, fromPos, searchContext) {
  const data = await searchAgentic(config, requestConfig, fromPos, searchContext);
  const generatedDslQuery = data?.output?.generated_dsl_query || data?.generated_dsl_query || '-';

  return {
    data: data?.output?.documents || [],
    originalQuery: data?.output?.original_query || searchContext?.query,
    usedQuery: data?.output?.query || searchContext?.query,
    accordionInfo: getAgenticInfo(generatedDslQuery) || null,
  };
}

export default function AiAgentSearch({ isLoading }) {
  if (!isLoading) {
    return null;
  }

  return <AgenticLoadingScreen />;
}
